import React, { useEffect, useState, useCallback, useRef } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Loader from "../../elements/Loader";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import Select from "react-select";
import StatusTracker from "../statusTracker/statusTracker";
import { useAuth } from "../../hooks/useAuth";
import CancelBookingModal from "../modal/CancelBookingModal";
import TicketResolveModal from "../modal/ticketResolveModal";
import AddressBookingModal from "../modal/addressBookingModal";

export default function AddBooking() {
  const params = useParams();
  const { id } = params;
  const { userId, role } = useAuth(); // admin user id
  const [loading, setLoading] = useState(false);
  const [pandit, setPandit] = useState([]);
  const [service, setService] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [bookingId, setBookingId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [customers, setCustomers] = useState([]);

  const [showTicketModal, setShowTicketModal] = useState(false)
  const [ticketId, setTicketId] = useState('')
  const [requestType, setRequestType] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [promoCodes, setPromoCodes] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [promoResponse, setPromoResponse] = useState(null);
  const [isPromoCodeApplied, setIsPromoCodeApplied] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [bookingExecutives, setBookingExecutives] = useState([]);
  const [assignMode, setAssignMode] = useState('manual'); // 'manual' | 'engine'
  const [allocationJob, setAllocationJob] = useState(null);
  const [allocationStarting, setAllocationStarting] = useState(false);

  const [userAddresses, setUserAddresses] = useState([]);
  const [variants, setVariants] = useState([]);
  const [geoPriceInfo, setGeoPriceInfo] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState('full'); // 'advance' | 'full'
  const [paymentMethodTab, setPaymentMethodTab] = useState('razorpay'); // 'razorpay' | 'manual'
  const [advanceAmount, setAdvanceAmount] = useState(1100); // configurable advance amount
  const [initialPaymentData, setInitialPaymentData] = useState({
    paymentMethod: '',
    amount: '',
    paymentId: ''
  });
  const formikRef = useRef();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    bookingId: "",
    serviceId: "",
    panditId: "",
    assignedBeId: "",
    pujaDateTime: "",
    bookingStatus: "",
    paymentStatus: "",
    user: {},
    transcribeText: "",
    previousStatus: "",
    modelType: "",
    cancelRemark: "",
    userId: "",
    service: {},
    userAddress: "",
    isInvoiceMailSent: "",
    agentPhone: "",
    pujaCheckinFilesArray: [],
    pujaCheckoutFilesArray: [],
    promoCodeId: "",
    campaignId: "",
    promoCode: {},
    discountAmount: "",
    actualPrice: "",
    finalPrice: "",
    bookingPaymentType: "",
    pandit: {},
    address: {},
    addressId: "",
    paymentLinkSent: false,
    isCustomPuja: false,
    variantId: "",
    variant: {},
    manualDiscount: "",
    discountType: "percentage",
    manualDiscountValue: "",
    proformaInvoiceUrl: "",
    finalInvoiceUrl: "",
    invoiceStatus: "pending",
    advancePaidAmount: 0,
    remainingAmount: 0,
  })

  const validationSchema = Yup.object().shape({
    //pujaDateTime: Yup.date().min(new Date(), "Booking date cannot be in the past").required("Date and time are required"),
    serviceId: Yup.string().required("Puja name is required"),
    userId: Yup.string().required("Customer is required")

  });

  const getVariantsByServiceId = useCallback(async (serviceId) => {
    try {
      const data = await ApiService.get(`service/${serviceId}/admin`);

      // Always include "Basic" option (main puja) as the first option
      const basicOption = {
        value: data?.result?.id || serviceId,
        label: data?.result?.variantType || 'Basic',
        price: data?.result?.price,
        isBasic: true // Flag to identify this as the main puja
      };

      if (data?.result?.variants) {
        const variantOptions = data.result.variants
          .filter(item => !item.isCustomPuja) // Exclude custom puja variants from dropdown
          .map((item) => ({
            value: item.id,
            label: item.variantType || 'Unknown Variant',
            price: item.price
          }));

        // Prepend Basic option to the variants list
        setVariants([basicOption, ...variantOptions]);
      } else {
        // If no variants exist, still show Basic option
        setVariants([basicOption]);
      }
    } catch (err) {
      console.log(err);
      setVariants([]);
    }
  }, []);


  const fetchGeoPrice = useCallback(async (serviceId, addressId, variantId) => {
    if (!serviceId || !addressId) return null;
    try {
      const params = new URLSearchParams({ serviceId, addressId });
      if (variantId) params.append('variantId', variantId);
      const data = await ApiService.get(`service/geo-price-for-booking?${params}`);
      if (data?.msg === 'success') {
        setGeoPriceInfo({
          detectedCity: data.detectedCity,
          citySource: data.citySource,
          tier: data.tier,
          isGeoPrice: data.isGeoPrice,
        });
        return data.price;
      }
    } catch (err) {
      console.log('geo price fetch error', err);
    }
    return null;
  }, []);

  const getPaymentHistory = useCallback(async (bookingId) => {
    if (!bookingId) return;
    try {
      const response = await ApiService.get(`booking/payment-history/${bookingId}`);
      if (response?.data) {
        setPaymentHistory(response.data);
        return response.data;
      }
    } catch (err) {
      console.error("Error fetching payment history:", err);
    }
  }, []);

  const getUserAddresses = useCallback(async (customUserId) => {
    const targetUserId = customUserId || initialValues?.userId;
    console.log(targetUserId, 'targetUserId')
    if (!targetUserId) return;
    try {
      const response = await ApiService.get(`user/address/${targetUserId}`);
      console.log(response?.data)
      setUserAddresses(response?.data || [])
    } catch (error) {
      console.error('Error fetching user addresses:', error);
      setUserAddresses([]);
    }
  }, [initialValues?.userId]);

const getBookingById = useCallback(async () => {
    console.log("Fetching booking with ID:", id);
    if (!id) {
      console.log("No booking ID available for fetching");
      return;
    }
    console.log("Fetching booking with ID:", id);
    setLoading(true);
    ApiService.get(`booking/${id}`).then((data) => {
      if (data?.result) {
        const { bookingId, panditId, pandit, pujaDateTime, bookingStatus, serviceId, paymentStatus, user, transcribeText, previousStatus, modelType, cancelRemark, userId, service, address, isInvoiceMailSent, agentPhone, pujaCheckinFilesArray, pujaCheckoutFilesArray, promoCodeId, campaignId, promoCode, discountAmount, actualPrice, finalPrice, bookingPaymentType, addressId, paymentLinkSent, isCustomPuja, variantId, variant, adminPaymentType, adminAdvanceAmount, discountType, manualDiscountValue, proformaInvoiceUrl, finalInvoiceUrl, invoiceStatus, advancePaidAmount, remainingAmount, panditPayout, dakshinaPaid, assignedBeId } = data?.result;
        const effectivePanditPayout = panditPayout ?? variant?.panditPayout ?? service?.panditPayout ?? "";

        setBookingId(bookingId)

        // Pre-fill payment plan choices if they were sent before
        if (adminPaymentType) {
          setSelectedPaymentType(adminPaymentType);
        }
        if (adminAdvanceAmount) {
          setAdvanceAmount(adminAdvanceAmount);
        }

        // Derive manualDiscount state from existing data:
        // If there's a discount amount but no promo code, and the discount is roughly 10% of the actual price.
        let derivedManualDiscount = "";
        const numericDiscount = parseFloat(discountAmount) || 0;
        let numericActualPrice = parseFloat(actualPrice) || 0;

        // If actualPrice is missing but we have finalPrice and discount, derive actualPrice
        if (numericActualPrice === 0 && finalPrice && numericDiscount > 0) {
          numericActualPrice = parseFloat(finalPrice) + numericDiscount;
        }

        if (!promoCodeId && numericDiscount > 0 && numericActualPrice > 0) {
          if (discountType === 'flat') {
            derivedManualDiscount = numericDiscount.toString();
          } else {
            const ratio = numericDiscount / numericActualPrice;
            const percentage = ratio * 100;
            // Check if it's a valid percentage (roughly)
            if (percentage > 0 && percentage <= 100) {
              derivedManualDiscount = parseFloat(percentage.toFixed(2)).toString();
            }
          }
        }

        const fullAddress = address
          ? [address.fullAddress, address.locality, address.direction]
            .filter(Boolean) // Removes falsy values (null, undefined, "")
            .join(', ') // Joins only available values with ', '
          : undefined;

        // Fetch variants for the service
        if (serviceId) {
          getVariantsByServiceId(serviceId);
        }

        setInitialValues({ bookingId, serviceId, panditId, pandit, pujaDateTime, bookingStatus, paymentStatus, user, transcribeText, previousStatus, modelType, cancelRemark, userId, service, address, ...(fullAddress && { userAddress: fullAddress }), isInvoiceMailSent, agentPhone, pujaCheckinFilesArray, pujaCheckoutFilesArray, promoCodeId, campaignId, promoCode, discountAmount, actualPrice, finalPrice, bookingPaymentType, addressId, paymentLinkSent, isCustomPuja, variantId, variant, adminPaymentType, adminAdvanceAmount, manualDiscount: derivedManualDiscount, discountType: discountType || 'percentage', manualDiscountValue: manualDiscountValue || derivedManualDiscount, proformaInvoiceUrl: proformaInvoiceUrl || "", finalInvoiceUrl: finalInvoiceUrl || "", invoiceStatus: invoiceStatus || "pending", advancePaidAmount: advancePaidAmount || 0, remainingAmount: remainingAmount || 0, panditPayout: effectivePanditPayout, dakshinaPaid: dakshinaPaid ?? effectivePanditPayout ?? "", assignedBeId: assignedBeId || "" });

        // Fetch payment history when booking is loaded
        if (bookingId) {
          getPaymentHistory(bookingId).then((freshHistory) => {
            if (freshHistory) {
              // If there's an existing payment but no admin payment type was set,
              // default the selected type to advance to show the Resend button
              const totalPaid = freshHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
              if (freshHistory.length > 0 && !adminPaymentType && totalPaid < (parseFloat(finalPrice) || 0)) {
                setSelectedPaymentType('advance');
              }
            }
          });
        }
      }
      setLoading(false);
    }).catch((err) => {
      console.log("Error fetching booking:", err);
      setLoading(false);
    });
  }, [id, getVariantsByServiceId, getPaymentHistory]);

  const getTicketsByBookingId = useCallback(async () => {
    ApiService.get(`booking/tickets/${bookingId}`).then((result) => {
      if (result?.data) {
        setTickets(result.data)
      }
    })
  }, [bookingId]);

  const getPandit = useCallback(async (searchTerm = '') => {
    ApiService.get(`user/role/pandit?dropdown=true${searchTerm ? `&search=${searchTerm}` : ''}`).then((data) => {
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: `${item.name}, ${item.phone}`,
        }));
        setPandit(options)
      }
    }).catch((err) => {
      console.log(err)
    })
  }, []);
  const getCustomers = useCallback(async (searchTerm = '') => {
    ApiService.get(`user/role/user?dropdown=true${searchTerm ? `&search=${searchTerm}` : ''}`).then((data) => {
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: `${item.name}, ${item.phone}`,
        }));
        setCustomers(options)
      }
    }).catch((err) => {
      console.log(err)
    })
  }, []);

  const getBookingExecutives = useCallback(async () => {
    ApiService.get(`user/role/booking_executive?dropdown=true`).then((data) => {
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: `${item.name}${item.phone ? `, ${item.phone}` : ''}`,
        }));
        setBookingExecutives(options);
      }
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  const getPujaList = useCallback(async () => {
    try {
      const data = await ApiService.get(`service/list`)
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: item.title,
          price: item.price // Include price for discount calculations
        }));

        setService(options);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);



  const getActivePromoCodes = useCallback(async (campaignId) => {
    try {
      const data = await ApiService.get(`promotion/active-promocodes${campaignId ? `?campaignId=${campaignId}` : ''}`)
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: item.code,
        }));

        setPromoCodes(options);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCampaigns = useCallback(async () => {
    try {
      const data = await ApiService.get(`promotion/active-campaigns`)
      if (data?.data) {
        const options = data.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setCampaigns(options);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);



  // Add this new useEffect to watch for initialValues.userId changes
  useEffect(() => {
    if (initialValues?.userId) {
      console.log('userId available, fetching addresses:', initialValues.userId);
      getUserAddresses();
    }
  }, [initialValues?.userId, getUserAddresses]); // This will run whenever initialValues.userId changes

  // Your existing useEffect (remove the getUserAddresses call from here)
  useEffect(() => {
    if (id) {
      getBookingById();
    }
    getPandit();
    getPujaList();
    getCustomers();
    getCampaigns();
    getBookingExecutives();
  }, [id, getBookingById, getPandit, getPujaList, getCustomers, getCampaigns, getBookingExecutives]);

  // Add new useEffect to handle campaign changes
  useEffect(() => {
    if (!id) {
      getActivePromoCodes();
    }
  }, [id, getActivePromoCodes]);

  useEffect(() => {
    if (bookingId) {
      getTicketsByBookingId();

    }
  }, [bookingId, getTicketsByBookingId]);

  useEffect(() => {
    if (!id || !initialValues.serviceId || !initialValues.addressId || initialValues.isCustomPuja) return;
    // If the booking already has a stored price, do not overwrite it with the
    // current live service price. The booked price is the source of truth.
    if (initialValues.finalPrice || initialValues.actualPrice) return;
    fetchGeoPrice(initialValues.serviceId, initialValues.addressId, initialValues.variantId || null)
      .then(geoPrice => {
        if (geoPrice === null || !formikRef.current) return;
        const discountVal = parseFloat(initialValues.manualDiscountValue) || 0;
        formikRef.current.setFieldValue('actualPrice', geoPrice);
        if (discountVal > 0) {
          let discount = 0;
          if (initialValues.discountType === 'flat') {
            discount = Math.min(discountVal, geoPrice);
          } else {
            discount = (geoPrice * discountVal) / 100;
          }
          formikRef.current.setFieldValue('discountAmount', discount.toFixed(2));
          formikRef.current.setFieldValue('finalPrice', (geoPrice - discount).toFixed(2));
        } else {
          formikRef.current.setFieldValue('finalPrice', geoPrice);
        }
      });
  }, [id, initialValues.serviceId, initialValues.addressId, initialValues.variantId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-detect if allocation engine is already running for this confirmed booking
  useEffect(() => {
    if (bookingId && initialValues.bookingStatus === 'confirmed') {
      fetchAllocationStatus(bookingId);
    }
  }, [bookingId, initialValues.bookingStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cleanup function to clear search timeouts
  useEffect(() => {
    return () => {
      clearTimeout(window.panditSearchTimeout);
      clearTimeout(window.customerSearchTimeout);
    };
  }, []);

  // --- Smart Polling: auto-detect Razorpay payments via webhook ---
  // Polls every 12s when a payment link has been sent and payment is still pending.
  // useEffect(() => {
  //   const shouldPoll = id && bookingId && initialValues?.paymentLinkSent && initialValues?.paymentStatus !== 'done';

  //   if (shouldPoll) {
  //     prevPaymentCountRef.current = paymentHistory.length;

  //     paymentPollRef.current = setInterval(async () => {
  //       try {
  //         const response = await ApiService.get(`booking/payment-history/${bookingId}`);
  //         const latestHistory = response?.data || [];

  //         if (latestHistory.length > prevPaymentCountRef.current) {
  //           const newPayment = latestHistory[0];
  //           const amountPaid = parseFloat(newPayment?.amount || 0).toFixed(2);

  //           toast.success(`✅ Payment of ₹${amountPaid} received! Updating records...`, { autoClose: 5000 });

  //           setPaymentHistory(latestHistory);
  //           prevPaymentCountRef.current = latestHistory.length;

  //           await getBookingById();

  //           const updatedBooking = await ApiService.get(`booking/${id}`);
  //           if (updatedBooking?.result?.paymentStatus === 'done') {
  //             clearInterval(paymentPollRef.current);
  //             paymentPollRef.current = null;
  //           }
  //         }
  //       } catch (err) {
  //         console.log('[Payment Poll] Error:', err.message);
  //       }
  //     }, 12000);
  //   }

  //   return () => {
  //     if (paymentPollRef.current) {
  //       clearInterval(paymentPollRef.current);
  //       paymentPollRef.current = null;
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id, bookingId, initialValues?.paymentLinkSent, initialValues?.paymentStatus]);

  /* 
  const updateTicketStatus = async (ticketId, bookingId, type) => {
    try {
      const updatedTicket = tickets.map((ticket) =>
        ticket.id === ticketId ? { ...ticket, status: "resolved" } : ticket
      );
      setTickets(updatedTicket);

      await ApiService.put(`/booking/tickets/${ticketId}`, { status: "resolved", bookingId, type });
      toast.success("Ticket marked as resolved");
    } catch (error) {
      console.error("Error updating ticket status:", error);
      toast.error("Failed to update ticket status");
    }
  };
  */




  const onSubmit = async (values) => {
    // Add validation for Assign Acharya action (only in manual mode)
    if (id && values.bookingStatus === 'confirmed' && assignMode === 'manual' && !values.panditId) {
      toast.error('Please select an Acharya before assigning');
      setIsSubmitting(false);
      setLoading(false);
      return;
    }

    values.beId = values.assignedBeId || userId;
    // Determine COD is completely removed
    setIsSubmitting(true);
    setLoading(true)
    try {
      if (id) {
        ApiService.put(`/booking/${id}`, values)
          .then((data) => {
            if (data.msg === 'success') {
              toast.success("Booking Updated");
            }
            setIsSubmitting(false)
            setLoading(false)
            if (tickets?.length > 0 && tickets.some(ticket => ticket.status === "pending")) {
              toast.info("There are pending ticket requests below!");
            } else {
              navigate('/booking', { replace: true });
            }
          }).catch((err) => {
            console.log(err)
          })
      } else {
        if (!isPromoCodeApplied) {
          values.promoCodeId = '';
          values.campaignId = '';
        } else {
          values.promoCodeId = promoResponse.promoCode.id;
          values.campaignId = promoResponse.promoCode.campaignId;
          values.finalPrice = promoResponse.finalPrice;
          values.discountAmount = promoResponse.discountAmount;
          values.actualPrice = promoResponse.actualPrice;
        }

        // Add initial payment data if provided
        if (initialPaymentData.paymentMethod && initialPaymentData.amount) {
          values.initialPayment = {
            paymentMethod: initialPaymentData.paymentMethod,
            amount: parseFloat(initialPaymentData.amount),
            paymentId: initialPaymentData.paymentId || null
          };
        }

        // Pass payment link choices directly so backend can send the combined unified notification
        if (selectedPaymentType) {
          values.adminPaymentType = selectedPaymentType;
          values.advanceAmount = advanceAmount;
        }

        ApiService.post('/booking', values)
          .then(async (data) => {
            if (data.msg === 'success') {
              toast.success("Booking has been Added");
              setIsSubmitting(false);
              setLoading(false);
              navigate('/booking', { replace: true });
            } else {
              toast.error(data.error || 'Failed to create booking');
              setIsSubmitting(false);
              setLoading(false);
            }
          }).catch((err) => {
            console.log('error', err);
            const errMsg = err.response?.data?.error || err.message || 'Something went wrong';
            toast.error(errMsg);
            setIsSubmitting(false);
            setLoading(false);
          })
      }
    } catch (error) {
      console.error('Error saving tag:', error);
    }
  }



  const handleGenerateInvoice = async (stage, force = false) => {
    if (!bookingId) {
      toast.error('Booking ID is missing');
      return;
    }
    setLoading(true);
    try {
      const response = await ApiService.post('booking/generate-invoice', { bookingId, stage, force });
      if (response?.msg === 'skipped') {
        toast.info(response.message || 'Invoice generation skipped.');
      } else if (response?.msg === 'success' && response?.invoiceUrl) {
        toast.success(`✅ ${stage === 'proforma' ? 'Proforma' : 'Tax'} Invoice generated successfully!`);
        getBookingById();
      } else {
        toast.error(response?.error || 'Invoice generation failed');
      }
    } catch (err) {
      console.error('Error generating invoice:', err);
      toast.error(err.response?.data?.error || err.message || 'Invoice generation failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSendInvoice = async (stage) => {
    if (!bookingId) {
      toast.error('Booking ID is missing');
      return;
    }
    setLoading(true);
    try {
      const response = await ApiService.post('booking/send-invoice', { bookingId, stage });
      if (response?.success || response?.message === 'Email and WhatsApp sent successfully!') {
        toast.success(`✉️ ${stage === 'proforma' ? 'Proforma' : 'Tax'} Invoice sent to customer successfully!`);
        getBookingById();
      } else {
        toast.error(response?.message || 'Failed to send invoice');
      }
    } catch (err) {
      console.error('Error sending invoice:', err);
      toast.error(err.response?.data?.error || err.message || 'Failed to send invoice');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text, label) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    toast.success(`📋 ${label} copied to clipboard!`);
  };


  const completedBooking = async (values, status) => {
    if (window.confirm('Are you sure you want to mark this booking as completed?')) {
      try {
        const updateData = {
          bookingStatus: status,
          finalPrice: values.finalPrice || null,
          actualPrice: values.actualPrice || null,
          discountAmount: values.discountAmount || null,
          promoCodeId: values.promoCodeId || null,
          campaignId: values.campaignId || null,
          serviceId: values.serviceId || null,
          variantId: values.variantId || null,
          pujaDateTime: values.pujaDateTime || null,
          addressId: values.addressId,
          discountType: values.discountType || null,
          manualDiscountValue: values.manualDiscountValue || null,
          modelType: values.modelType || null
        }

        await ApiService.post('booking/update-data', { bookingId: values.bookingId, data: updateData });
        toast.success('Booking status updated successfully');
        getBookingById();
      } catch (error) {
        console.error('Error updating booking status:', error);
        toast.error('Failed to update booking status');
      }
    }
  }

  const openTicketModal = (ticketId, bookingId, requestType) => {
    setShowTicketModal(true)
    setRequestType(requestType)
    setTicketId(ticketId)
  }
  const applyPromoCode = async (promoCodeId, userId, serviceId) => {
    if (!promoCodeId || !userId || !serviceId) {
      toast.error('Please select all required fields (Customer, Service, and Promo Code)');
      return;
    }

    try {
      const response = await ApiService.post('promotion/apply-promocode', {
        promoCodeId,
        userId,
        serviceId
      });

      if (response?.status === 'success') {
        const { discountAmount, finalPrice, promoCode, actualPrice } = response.data;
        setPromoResponse({ discountAmount, finalPrice, promoCode, actualPrice });
        setIsPromoCodeApplied(true);
        toast.success(`Promo code ${promoCode.code} applied successfully!`);
      } else {
        setIsPromoCodeApplied(false);
        toast.error(response?.msg || 'Failed to apply promo code');
      }
    } catch (error) {
      setIsPromoCodeApplied(false);
      console.error('Error applying promo code:', error);

      // Handle different error cases
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const errorMessage = error.response?.data?.msg || 'Failed to apply promo code';
        toast.error(errorMessage);
      } else if (error.request) {
        // The request was made but no response was received
        toast.error('No response from server. Please try again.');
      } else {
        // Something happened in setting up the request that triggered an Error
        toast.error('An error occurred. Please try again.');
      }
    }
  }

  const handleAddressSubmit = async (addressData) => {
    try {
      console.log(addressData)
      // Call the API with the address data and update booking status
      const values = formikRef.current?.values || {};
      const data = {
        finalPrice: values.finalPrice || null,
        actualPrice: values.actualPrice || null,
        discountAmount: values.discountAmount || null,
        promoCodeId: values.promoCodeId || null,
        campaignId: values.campaignId || null,
        serviceId: values.serviceId || null,
        variantId: values.variantId || null,
        pujaDateTime: values.pujaDateTime || null,
        discountType: values.discountType || null,
        manualDiscountValue: values.manualDiscountValue || null,
        modelType: values.modelType || null
      }

      const response = await ApiService.post('booking/update-data', {
        bookingId: bookingId,
        data: data,
        addressData
      });
      if (response.msg === 'success') {
        toast.success('Address updated successfully');
      } else {
        toast.error(response.error);
      }
      //navigate('/booking', { replace: true });
      getBookingById(); // Refresh booking data
    } catch (error) {
      console.error('Error submitting address and confirming booking:', error);
      toast.error('Failed to add address and confirm booking');
      throw error;
    }
  };

  const confirmBooking = async (values) => {
    const { addressId, bookingId } = values;

    // Check if address is selected
    if (!addressId) {
      toast.error('Please select an address before confirming the booking');
      return;
    }

    try {
      const data = {
        bookingStatus: 'confirmed',
        finalPrice: values.finalPrice || null,
        actualPrice: values.actualPrice || null,
        discountAmount: values.discountAmount || null,
        promoCodeId: values.promoCodeId || null,
        campaignId: values.campaignId || null,
        serviceId: values.serviceId || null,
        variantId: values.variantId || null,
        pujaDateTime: values.pujaDateTime || null,
        discountType: values.discountType || null,
        manualDiscountValue: values.manualDiscountValue || null,
        modelType: values.modelType || null
      }

      const response = await ApiService.post('booking/update-data', {
        bookingId: bookingId,
        data: data,
        addressId
      });
      if (response.msg === 'success') {
        toast.success('Booking Confirmed successfully');
        getBookingById(); // Refresh booking data to show updated status
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.error('Error confirming booking:', error);
      toast.error('Failed to confirm booking');
    }
  };

  // get user addresses


  // useEffect(() => {
  //   const interval = setInterval(() => {
  //         window.location.reload(); // Refresh the page
  //     }, 5 * 60 * 1000); // 5 minutes in milliseconds

  //     return () => clearInterval(interval); // Cleanup interval on component unmount
  // }, []);

  const sendPaymentLink = async (bookingId, paymentType) => {
    if (!paymentType) {
      toast.error('Please select a payment option first');
      return;
    }

    try {
      const values = formikRef.current?.values || initialValues;
      const bookingAmount = parseFloat(values.finalPrice || values.actualPrice || initialValues?.finalPrice || initialValues?.actualPrice || 0);

      // Always fetch FRESH payment history — never rely on stale React state
      let freshTotalReceived = 0;
      try {
        const histResp = await ApiService.get(`booking/payment-history/${bookingId}`);
        const freshHistory = histResp?.data || [];
        freshTotalReceived = freshHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        setPaymentHistory(freshHistory);
      } catch (e) {
        console.warn('[sendPaymentLink] Could not fetch fresh history, falling back to state:', e.message);
        freshTotalReceived = Array.isArray(paymentHistory)
          ? paymentHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
          : 0;
      }

      let effectivePaymentType = paymentType;
      let amountToCharge = bookingAmount - freshTotalReceived;

      // If user specifically chose "advance" and provided an amount, use that instead of full remaining balance
      if (paymentType === 'advance' && advanceAmount) {
        amountToCharge = parseFloat(advanceAmount);
      }


      const confirmMessage =
        `Send payment link\n\n` +
        `• Total booking amount: ₹${bookingAmount}\n` +
        `• Already received: ₹${freshTotalReceived.toFixed(0)}\n` +
        `• Amount for this link: ₹${amountToCharge}\n`;

      if (!window.confirm(confirmMessage)) return;

      const remainingAfterPayment = Math.max(0, bookingAmount - freshTotalReceived - amountToCharge);

      const response = await ApiService.post(`booking/send-payment-link/${bookingId}`, {
        remainingAmount: amountToCharge,
        bookingAmount: bookingAmount,
        totalReceived: freshTotalReceived,
        paymentType: effectivePaymentType,
        amountDue: amountToCharge,
        remainingAfterPayment: remainingAfterPayment
      });

      if (response.msg === 'success') {
        toast.success(`Payment link for ₹${amountToCharge} sent successfully`);
        getBookingById();
      } else {
        toast.error(response.error || 'Failed to send payment link');
      }
    } catch (error) {
      console.error('Error sending payment link:', error);
      toast.error('Failed to send payment link');
    }
  };

  const deletePaymentRecord = async (paymentId) => {
    if (window.confirm('Are you sure you want to delete this payment record? This action cannot be undone.')) {
      try {
        await ApiService.delete(`booking/payment-history/${paymentId}`);
        toast.success('Payment record deleted successfully');
        getPaymentHistory(bookingId);
        getBookingById();
      } catch (error) {
        console.error('Error deleting payment record:', error);
        toast.error('Failed to delete payment record');
      }
    }
  };

  const handleCommonUpdate = async (values) => {
    // Validation: Acharya cannot be edited when status is nurtured
    if (values.modelType === 'nurture' && values.panditId !== initialValues.panditId) {
      toast.error('Acharya cannot be edited when the status is nurtured', {
        position: "top-right"
      });
      return;
    }

    setLoading(true);
    try {
      const updateData = {};
      
      // Collect only changed fields
      if (values.pujaDateTime !== initialValues.pujaDateTime) {
        updateData.pujaDateTime = values.pujaDateTime || null;
      }
      if (values.serviceId !== initialValues.serviceId) {
        updateData.serviceId = values.serviceId || null;
      }
      if (values.variantId !== initialValues.variantId) {
        updateData.variantId = values.variantId || null;
      }
      if (values.panditId !== initialValues.panditId) {
        updateData.panditId = values.panditId || null;
      }
      if (values.addressId !== initialValues.addressId) {
        updateData.addressId = values.addressId || null;
      }
      if (values.modelType !== initialValues.modelType) {
        updateData.modelType = values.modelType || null;
      }
      if (values.assignedBeId !== initialValues.assignedBeId) {
        updateData.assignedBeId = values.assignedBeId || null;
      }
      
      // Discount related fields
      if (
        values.manualDiscountValue !== initialValues.manualDiscountValue ||
        values.discountType !== initialValues.discountType ||
        values.finalPrice !== initialValues.finalPrice
      ) {
        updateData.finalPrice = values.finalPrice || null;
        updateData.actualPrice = values.actualPrice || null;
        updateData.discountAmount = values.discountAmount || null;
        updateData.discountType = values.discountType || 'percentage';
        updateData.manualDiscountValue = values.manualDiscountValue || null;
      }

      const response = await ApiService.post('booking/update-data', {
        bookingId: values.bookingId,
        data: updateData
      });

      if (response?.msg === 'success') {
        toast.success('Booking details updated successfully');
        getBookingById();
      } else {
        toast.error(response?.error || 'Failed to update booking details');
      }
    } catch (error) {
      console.error('Error in common update:', error);
      toast.error('An error occurred while updating');
    } finally {
      setLoading(false);
    }
  };

  const isAnyFieldUpdated = (values) => {
    if (!id) return false;

    return (
      values.pujaDateTime !== initialValues.pujaDateTime ||
      values.serviceId !== initialValues.serviceId ||
      values.variantId !== initialValues.variantId ||
      values.panditId !== initialValues.panditId ||
      values.addressId !== initialValues.addressId ||
      values.modelType !== initialValues.modelType ||
      values.manualDiscountValue !== initialValues.manualDiscountValue ||
      values.discountType !== initialValues.discountType ||
      values.finalPrice !== initialValues.finalPrice ||
      values.assignedBeId !== initialValues.assignedBeId
    );
  };

  const fetchAllocationStatus = useCallback(async (bId) => {
    const target = bId || bookingId;
    if (!target) return;
    try {
      const data = await ApiService.get(`allocation/status/${target}`);
      if (data?.job) {
        setAllocationJob(data.job);
        setAssignMode('engine');
      }
    } catch (_) {}
  }, [bookingId]);

  const handleStartAllocation = async () => {
    if (!bookingId) return;
    setAllocationStarting(true);
    try {
      await ApiService.post('allocation/start', { bookingId });
      toast.success('Allocation engine started — track progress in the Allocation Dashboard');
      fetchAllocationStatus();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Failed to start allocation engine';
      if (err.response?.status === 409) {
        toast.info('Allocation engine is already running for this booking');
        fetchAllocationStatus();
      } else {
        toast.error(msg);
      }
    } finally {
      setAllocationStarting(false);
    }
  };

  const getButtonText = () => {
    if (!id) return 'Create Booking';

    switch (initialValues.bookingStatus) {
      case 'pending':
        return 'Confirm Booking';
      case 'confirmed':
        return 'Assign Acharya';
      default:
        return 'Update';
    }
  };

  return (
    <div className="row" key={initialValues}>
      {loading && <Loader />}


      <div className="col-xl-8 col-lg-12 offset-md-2" >
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">{id ? 'Edit' : 'Add'} Booking</h4>
            <div className="card-header-right">
              <span>Booking Payment Type: {initialValues?.bookingPaymentType}</span>
            </div>
          </div>
          <div className="card-body">
            <Formik
              initialValues={initialValues}
              validate={(values) => {
                const errors = {};

                // Conditionally validate dateAndTime
                if (values.modelType !== "nurture") {
                  if (!values.pujaDateTime) {
                    errors.pujaDateTime = "Date and time are required";
                  }
                  // NOTE: Past date validation temporarily disabled to allow back-dated bookings
                  // Uncomment the code below to re-enable:
                  // else {
                  //   const selectedDateTime = new Date(values.pujaDateTime);
                  //   const currentDateTime = new Date();
                  //   if (selectedDateTime < currentDateTime) {
                  //     errors.pujaDateTime = "Date and time cannot be in the past";
                  //   }
                  // }
                }

                // Address is required for new bookings only
                if (!id && !values.addressId) {
                  errors.addressId = "Address is required";
                }

                return errors;
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
              innerRef={formikRef}
            >
              {({ setFieldValue, values, errors }) => {
                const isPujaStartedOrCompleted = values.bookingStatus === 'puja_started' || values.bookingStatus === 'puja_completed';
                const totalReceivedVal = Array.isArray(paymentHistory) ? paymentHistory.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0) : 0;
                const bookingAmountVal = parseFloat(values?.finalPrice || values?.actualPrice || 0);
                const remainingAmountVal = Math.max(0, bookingAmountVal - totalReceivedVal);

                const getAcharyaDetails = () => {
                  if (values?.panditId === initialValues?.panditId && initialValues?.pandit?.name) {
                    return `${initialValues.pandit.name}${initialValues.pandit.phone ? ` (${initialValues.pandit.phone})` : ''}`;
                  }
                  const selectedOption = pandit?.find((item) => item.value === values?.panditId);
                  if (selectedOption) {
                    return selectedOption.label;
                  }
                  if (values?.panditId) {
                    return `Assigned (ID: ${values.panditId})`;
                  }
                  return 'Not Assigned';
                };

                const getAcharyaPhone = () => {
                  if (values?.panditId === initialValues?.panditId && initialValues?.pandit?.phone) {
                    return initialValues.pandit.phone;
                  }
                  const selectedOption = pandit?.find((item) => item.value === values?.panditId);
                  if (selectedOption) {
                    // dropdown label format: "Name, Phone"
                    const parts = selectedOption.label.split(', ');
                    return parts.length > 1 ? parts[parts.length - 1] : 'Contact Unavailable';
                  }
                  return values?.panditId ? 'Contact Unavailable' : 'Not Assigned';
                };

                return (
                <>
                    <div className="booking-summary-minimal border rounded bg-white p-3 mb-4">
                      <div className="row mb-2 border-bottom pb-2">
                        <div className="col-md-6">
                           <h6 className="mb-0 text-dark">Booking Details Summary</h6>
                        </div>
                        <div className="col-md-6 text-end small">
                           <strong>Booking Status:</strong> <span className={values?.bookingStatus === 'completed' ? 'text-success' : 'text-primary'}>{values?.bookingStatus?.toUpperCase() || 'NEW'}</span>
                        </div>
                      </div>

                      <div className="row small">
                        {/* Column 1: Customer Details */}
                        <div className="col-md-3 border-end">
                          <div className="mb-1">
                            <span className="text-muted">Customer:</span> <br/>
                            <strong>{values?.user?.name || 'Not Selected'}</strong>
                          </div>
                          <div>
                            <span className="text-muted">Phone:</span> <br/>
                            <strong>{values?.user?.phone || 'Not Selected'}</strong>
                          </div>
                        </div>

                        {/* Column 4: Acharya & Address Details */}
                        <div className="col-md-5 border-end">
                          <div className="mb-1">
                            <span className="text-muted">Service Address:</span> <br/>
                            <strong>{values?.userAddress ? values.userAddress : 'Not Added'}</strong>
                          </div>
                          <div>
                            <span className="text-muted">Acharya Contact:</span> <br/>
                            <strong>{getAcharyaPhone()}</strong>
                          </div>
                        </div>

                        {/* Column 3: Pricing Minimal */}
                        <div className="col-md-4">
                          {geoPriceInfo?.isGeoPrice && (
                            <div className="mb-2">
                              <span className="badge bg-success me-1">Geo Price</span>
                              <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                                {geoPriceInfo.detectedCity}
                                {geoPriceInfo.citySource === 'extracted' && (
                                  <span className="text-warning ms-1" title="City auto-detected from address — please verify">⚠ auto-detected</span>
                                )}
                              </span>
                            </div>
                          )}
                          <div className="d-flex justify-content-between mb-1">
                            <span>Actual Price:</span>
                            <strong>₹{values?.actualPrice || values?.finalPrice || 0}</strong>
                          </div>
                          {values?.discountAmount > 0 && (
                            <div className="d-flex justify-content-between mb-1 text-success font-italic">
                              <span>Manual Discount:</span>
                              <strong>- ₹{values?.discountAmount}</strong>
                            </div>
                          )}
                          <div className="d-flex justify-content-between align-items-center border-top pt-1 mt-1">
                            <span className="fw-bold">Final Amount:</span>
                            {id ? (
                              <Field
                                type="number"
                                name="finalPrice"
                                className="form-control form-control-sm text-end fw-bold text-primary"
                                style={{ width: '80px', padding: '2px 6px', fontSize: '0.85rem' }}
                                placeholder="0"
                                min="0"
                                disabled={isPujaStartedOrCompleted}
                              />
                            ) : (
                              <span className="fw-bold text-primary">₹{values?.finalPrice || values?.actualPrice || 0}</span>
                            )}
                          </div>
                          {id && (
                            <div className="mt-2 pt-2 border-top small text-muted">
                              <div className="d-flex justify-content-between mb-1">
                                <span>Actual Price:</span>
                                <strong>₹{parseFloat(values?.actualPrice || values?.finalPrice || 0)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span>Booking Amount:</span>
                                <strong>₹{parseFloat(values?.finalPrice || values?.actualPrice || 0)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span>Total Received:</span>
                                <strong className="text-success">₹{totalReceivedVal.toFixed(2)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span>Remaining Amount:</span>
                                <strong className="text-danger">₹{remainingAmountVal.toFixed(2)}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span>Acharya Assigned:</span>
                                <strong className="text-end">{getAcharyaDetails()}</strong>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span>Payment Type:</span>
                                <strong className="text-capitalize">{values?.bookingPaymentType || 'N/A'}</strong>
                              </div>
                            </div>
                          )}
                          <div className="mt-2 text-end">
                             <span className="text-muted">Payment:</span> 
                             <span className={`ms-1 fw-bold ${values?.paymentStatus === 'done' ? 'text-success' : 'text-warning'}`}>
                               {values?.paymentStatus === 'done' ? 'Paid' : values?.paymentStatus === 'partial' ? 'Partial' : 'Pending'}
                             </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                    <StatusTracker currentStatus={values?.bookingStatus} previousStatus={values?.previousStatus} />
                  </div>
                  <div className="basic-form">
                    <Form>
                      <div className="row mt-3">
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Date & Time <span className="text-danger">*</span></label>
                          <div className="d-flex align-items-center">
                            <Field 
                              type="datetime-local" 
                              id="pujaDateTime" 
                              name="pujaDateTime" 
                              className="form-control" 
                              disabled={isPujaStartedOrCompleted}
                            />
                          </div>
                          {/* <ErrorMessage name="pujaDateTime" component="div" style={{ color: 'red' }} /> */}
                          {errors.pujaDateTime && <div style={{ color: 'red' }}>{errors.pujaDateTime}</div>}
                        </div>
                        <div className="mb-3 col-md-6">
                          <label className="form-label"> Select Puja <span className="text-danger">*</span></label>
                          <Select
                            name="serviceId"
                            options={service}
                            isDisabled={isPujaStartedOrCompleted}
                            onChange={async (selectedOptions) => {
                              setFieldValue("serviceId", selectedOptions?.value)
                              setIsPromoCodeApplied(false)
                              setGeoPriceInfo(null)

                              if (selectedOptions?.price) {
                                const newServiceId = selectedOptions.value;
                                // If address already selected, fetch geo price; otherwise use base price
                                const geoPrice = values.addressId
                                  ? await fetchGeoPrice(newServiceId, values.addressId, null)
                                  : null;
                                const price = geoPrice ?? selectedOptions.price;

                                setFieldValue("actualPrice", price);
                                setFieldValue("finalPrice", price);
                                setFieldValue("discountAmount", 0);

                                if (values.manualDiscount) {
                                  const discountVal = parseFloat(values.manualDiscount);
                                  if (!isNaN(discountVal) && discountVal > 0) {
                                    let discount = 0;
                                    if (values.discountType === 'flat') {
                                      discount = Math.min(discountVal, price);
                                    } else {
                                      discount = (price * discountVal) / 100;
                                    }
                                    setFieldValue("actualPrice", price);
                                    setFieldValue("discountAmount", discount.toFixed(2));
                                    setFieldValue("finalPrice", (price - discount).toFixed(2));
                                  }
                                }
                              }

                              // Fetch variants for the selected service
                              if (selectedOptions?.value) {
                                getVariantsByServiceId(selectedOptions.value)
                              } else {
                                setVariants([])
                              }
                              // Reset variant selection when service changes
                              setFieldValue("variantId", null)
                            }}
                            value={service?.find((item) => item.value === values?.serviceId)}

                          />
                          <ErrorMessage
                            name="serviceId"
                            component="div"
                            className="error-message"
                          />
                        </div>
                        {/* Booking Executive Selector */}
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Booking Executive</label>
                          <Select
                            name="assignedBeId"
                            options={bookingExecutives}
                            onChange={(selectedOption) => {
                              setFieldValue("assignedBeId", selectedOption?.value || "");
                            }}
                            value={bookingExecutives.find((item) => item.value === values.assignedBeId) || null}
                            placeholder="Select Booking Executive..."
                            isClearable
                          />
                        </div>

                        {/* Variant Selector - available for all bookings, disabled for Custom Puja */}
                        <div className="mb-3 col-md-6">
                          <label className="form-label">
                            Variant {values?.isCustomPuja && <span className="badge bg-warning ms-2">Custom Puja</span>}
                          </label>
                          <Select
                              name="variantId"
                              options={variants}
                              onChange={async (selectedOptions) => {
                                setFieldValue("variantId", selectedOptions?.value)
                                if (selectedOptions?.price) {
                                  // Fetch geo price whenever an address is already selected (both create and edit mode)
                                  const geoPrice = values.addressId
                                    ? await fetchGeoPrice(values.serviceId, values.addressId, selectedOptions.value)
                                    : null;
                                  const price = geoPrice ?? selectedOptions.price;

                                  const discountVal = parseFloat(values.manualDiscount);
                                  if (!isNaN(discountVal) && discountVal > 0) {
                                    let discount = 0;
                                    if (values.discountType === 'flat') {
                                      discount = Math.min(discountVal, price);
                                    } else {
                                      discount = (price * discountVal) / 100;
                                    }
                                    setFieldValue("actualPrice", price);
                                    setFieldValue("discountAmount", discount.toFixed(2));
                                    setFieldValue("finalPrice", (price - discount).toFixed(2));
                                  } else {
                                    setFieldValue("finalPrice", price)
                                    setFieldValue("actualPrice", price)
                                    setFieldValue("discountAmount", 0)
                                  }
                                }
                              }}
                              value={variants?.find((item) => item.value === values?.variantId)}
                              isDisabled={isPujaStartedOrCompleted || values?.isCustomPuja || variants.length === 0} // Disabled for custom puja, or when no variants
                            placeholder={values?.isCustomPuja ? "Custom Puja" : variants.length === 0 ? "Select a Puja first" : "Select Variant..."}
                          />
                        </div>
                        {/* Custom Price for Custom Puja Bookings */}
                        {id && values?.isCustomPuja && (
                          <div className="mb-3 col-md-6">
                            <label className="form-label">
                              Custom Puja Price <span className="text-danger">*</span>
                              {values?.bookingStatus === 'lead' && <span className="badge bg-info ms-2">Set to Confirm</span>}
                            </label>
                            <Field
                              type="number"
                              name="finalPrice"
                              className="form-control"
                              placeholder="Enter custom price"
                            />
                            <small className="text-muted">Set the price to confirm this Custom Puja booking</small>
                          </div>
                        )}
                        {(values?.bookingStatus === 'confirmed' || values?.bookingStatus === 'acharya_assigned' || values?.bookingStatus === 'samagri_delivered') && (
                          <div className="mb-3 col-md-6">
                            {values?.bookingStatus === 'confirmed' ? (
                              <>
                                <label className="form-label fw-bold">Assign Acharya</label>

                                {/* Mode toggle */}
                                <div className="d-flex gap-2 mb-3">
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${assignMode === 'manual' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => setAssignMode('manual')}
                                  >
                                    Manual Assignment
                                  </button>
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${assignMode === 'engine' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => setAssignMode('engine')}
                                  >
                                    Allocation Engine
                                  </button>
                                </div>

                                {assignMode === 'manual' ? (
                                  <>
                                    <Select
                                      name="panditId"
                                      options={pandit}
                                      isDisabled={isPujaStartedOrCompleted}
                                      onChange={(selectedOptions) => {
                                        if (values.modelType === 'nurture') {
                                          toast.error('Acharya cannot be edited when the status is nurtured', { position: "top-right" });
                                          return;
                                        }
                                        setFieldValue("panditId", selectedOptions?.value);
                                      }}
                                      onInputChange={(inputValue) => {
                                        clearTimeout(window.panditSearchTimeout);
                                        window.panditSearchTimeout = setTimeout(() => getPandit(inputValue), 300);
                                      }}
                                      value={pandit?.find((item) => item.value === values?.panditId)}
                                      className={!values.panditId ? 'is-invalid' : ''}
                                      placeholder="Search and select Acharya..."
                                      isSearchable={true}
                                      noOptionsMessage={({ inputValue }) =>
                                        inputValue ? `No Acharya found for "${inputValue}"` : "No Acharya available"
                                      }
                                    />
                                    {!values.panditId && (
                                      <div className="invalid-feedback d-block">Please select an Acharya to assign</div>
                                    )}
                                    {!values.isInvoiceMailSent && values.bookingPaymentType !== 'cod' && (
                                      <small className="text-muted d-block mt-1">Please send the invoice below before assigning acharya</small>
                                    )}
                                  </>
                                ) : (
                                  /* Allocation Engine mode */
                                  allocationJob ? (
                                    <div className="border rounded p-3 bg-light">
                                      <div className="d-flex align-items-center gap-2 mb-2">
                                        <span className={`badge ${allocationJob.status === 'active' ? 'bg-success' : allocationJob.status === 'escalated' ? 'bg-danger' : 'bg-secondary'}`}>
                                          {allocationJob.status?.toUpperCase()}
                                        </span>
                                        <strong>Engine Running</strong>
                                      </div>
                                      <div className="small text-muted">
                                        <div>Wave #{allocationJob.windowNumber} — Radius: {allocationJob.currentRadius}km</div>
                                        {allocationJob.panditsContactedCount > 0 && (
                                          <div>Pandits notified: {allocationJob.panditsContactedCount}</div>
                                        )}
                                        {allocationJob.windowEnd && (
                                          <div>Window ends: {new Date(allocationJob.windowEnd).toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short' })}</div>
                                        )}
                                      </div>
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary mt-2"
                                        onClick={() => navigate('/allocation-dashboard')}
                                      >
                                        View in Allocation Dashboard
                                      </button>
                                    </div>
                                  ) : (
                                    <div>
                                      <p className="text-muted small mb-2">
                                        The engine will automatically find and notify pandits within 5km, expanding to 10km, 15km, and 20km if no one accepts within 2 hours.
                                      </p>
                                      <button
                                        type="button"
                                        className="btn btn-success"
                                        disabled={allocationStarting}
                                        onClick={handleStartAllocation}
                                      >
                                        {allocationStarting ? 'Starting...' : 'Start Allocation Engine'}
                                      </button>
                                    </div>
                                  )
                                )}
                              </>
                            ) : (
                              /* acharya_assigned / samagri_delivered — just show the dropdown for acharya change */
                              <>
                                <label className="form-label">Select Acharya</label>
                                <Select
                                  name="panditId"
                                  options={pandit}
                                  isDisabled={isPujaStartedOrCompleted}
                                  onChange={(selectedOptions) => {
                                    if (values.modelType === 'nurture') {
                                      toast.error('Acharya cannot be edited when the status is nurtured', { position: "top-right" });
                                      return;
                                    }
                                    setFieldValue("panditId", selectedOptions?.value);
                                  }}
                                  onInputChange={(inputValue) => {
                                    clearTimeout(window.panditSearchTimeout);
                                    window.panditSearchTimeout = setTimeout(() => getPandit(inputValue), 300);
                                  }}
                                  value={pandit?.find((item) => item.value === values?.panditId)}
                                  placeholder="Search and select Acharya..."
                                  isSearchable={true}
                                  noOptionsMessage={({ inputValue }) =>
                                    inputValue ? `No Acharya found for "${inputValue}"` : "No Acharya available"
                                  }
                                />
                                <ErrorMessage name="panditId" component="div" className="error-message" />
                              </>
                            )}
                          </div>
                        )}

                        {/* Discount Selector - Available for both new and existing bookings */}


                        {(!id) && (
                          <>
                            <div className="mb-3 col-md-6">
                              <label className="form-label">Select Campaign </label>
                              <Select
                                name="campaignId"
                                options={campaigns}
                                onChange={(selectedOptions) => {
                                  setFieldValue("campaignId", selectedOptions?.value);
                                  setFieldValue("promoCodeId", ""); // Reset promo code when campaign changes
                                  getActivePromoCodes(selectedOptions?.value);
                                  setIsPromoCodeApplied(false)
                                }}
                                value={campaigns?.find((item) => item.value === values?.campaignId)}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label className="form-label">Select Customer</label>
                              <Select
                                name="userId"
                                options={customers}
                                onChange={async (selectedOptions) => {
                                  const selectedUserId = selectedOptions?.value;
                                  setFieldValue("userId", selectedUserId);
                                  setIsPromoCodeApplied(false);

                                  // Fetch and set the full user details for display
                                  if (selectedUserId) {
                                    getUserAddresses(selectedUserId);
                                    try {
                                      const userData = await ApiService.get(`user/${selectedUserId}`);
                                      if (userData?.result) {
                                        setFieldValue("user", {
                                          name: userData.result.name,
                                          phone: userData.result.phone,
                                          email: userData.result.email
                                        });
                                      }
                                    } catch (error) {
                                      console.error('Error fetching customer details:', error);
                                    }
                                  } else {
                                    // Clear user details if no customer selected
                                    setFieldValue("user", {});
                                  }
                                }}
                                onInputChange={(inputValue) => {
                                  // Debounce search to avoid too many API calls
                                  clearTimeout(window.customerSearchTimeout);
                                  window.customerSearchTimeout = setTimeout(() => {
                                    getCustomers(inputValue);
                                  }, 300);
                                }}
                                value={customers?.find((item) => item.value === values?.userId)}
                                placeholder="Search and select Customer..."
                                isSearchable={true}
                                noOptionsMessage={({ inputValue }) =>
                                  inputValue ? `No Customer found for "${inputValue}"` : "No Customer available"
                                }
                              />
                              <ErrorMessage
                                name="userId"
                                component="div"
                                className="error-message"
                              />
                            </div>
                          </>
                        )}

                        {/* Discount Selector - Available for both new and existing bookings */}
                        <div className="mb-3 col-md-6">
                          <label className="form-label">Discount</label>
                          <div className="d-flex align-items-center">
                            <div className="input-group">
                              <input
                                type="number"
                                name="manualDiscount"
                                className="form-control"
                                disabled={isPujaStartedOrCompleted}
                                placeholder={values.discountType === 'percentage' ? "Enter percentage" : "Enter amount"}
                                min="0"
                                max={values.discountType === 'percentage' ? "100" : undefined}
                                step="0.01"
                                value={values.manualDiscount}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  const discountVal = parseFloat(val);
                                  const price = values.actualPrice || values.finalPrice || 0;

                                  if (val === '' || isNaN(discountVal)) {
                                    setFieldValue("manualDiscount", val);
                                    setFieldValue("manualDiscountValue", "");
                                    setFieldValue("discountAmount", 0);
                                    setFieldValue("finalPrice", price);
                                    return;
                                  }

                                  if (values.discountType === 'percentage') {
                                    if (discountVal >= 0 && discountVal <= 100) {
                                      const discount = (price * discountVal) / 100;
                                      setFieldValue("manualDiscount", val);
                                      setFieldValue("manualDiscountValue", val);
                                      setFieldValue("discountAmount", discount.toFixed(2));
                                      setFieldValue("finalPrice", (price - discount).toFixed(2));
                                      setFieldValue("promoCodeId", ""); 
                                      setIsPromoCodeApplied(false);
                                    }
                                  } else {
                                    if (discountVal >= 0 && discountVal <= price) {
                                      setFieldValue("manualDiscount", val);
                                      setFieldValue("manualDiscountValue", val);
                                      setFieldValue("discountAmount", discountVal.toFixed(2));
                                      setFieldValue("finalPrice", (price - discountVal).toFixed(2));
                                      setFieldValue("promoCodeId", ""); 
                                      setIsPromoCodeApplied(false);
                                    }
                                  }
                                }}
                              />
                              <select
                                className="form-select"
                                style={{ maxWidth: '100px' }}
                                value={values.discountType}
                                disabled={isPujaStartedOrCompleted}
                                onChange={(e) => {
                                  const newType = e.target.value;
                                  setFieldValue("discountType", newType);
                                  
                                  // Recalculate based on existing manualDiscount if present
                                  if (values.manualDiscount) {
                                    const discountVal = parseFloat(values.manualDiscount);
                                    const price = values.actualPrice || values.finalPrice || 0;
                                    
                                    if (!isNaN(discountVal)) {
                                      let discount = 0;
                                      if (newType === 'percentage') {
                                        discount = (price * Math.min(discountVal, 100)) / 100;
                                      } else {
                                        discount = Math.min(discountVal, price);
                                      }
                                      setFieldValue("discountAmount", discount.toFixed(2));
                                      setFieldValue("finalPrice", (price - discount).toFixed(2));
                                    }
                                  }
                                }}
                              >
                                <option value="percentage">%</option>
                                <option value="flat">Fixed</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {(!id) && (
                          <>
                            {/* Force new row for Promo Code */}
                            <div className="w-100"></div>

                            <div className="mb-3 col-md-6">
                              <label className="form-label">Select Promo code</label>
                              <Select
                                name="promoCodeId"
                                options={promoCodes}
                                onChange={(selectedOptions) => {
                                  setFieldValue("promoCodeId", selectedOptions?.value)
                                  setIsPromoCodeApplied(false)
                                }}
                                value={promoCodes?.find((item) => item.value === values?.promoCodeId)}
                                isDisabled={!values.campaignId} // Disable if no campaign selected
                              />
                            </div>
                            <div className="mt-4 col-md-6">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  setFieldValue("manualDiscount", "");
                                  applyPromoCode(values.promoCodeId, values.userId, values.serviceId);
                                }}
                              >
                                Apply Promo Code
                              </button>
                            </div>
                          </>
                        )}
                        {(id) && (
                          <div className="mb-3 col-md-6">
                            <label className="form-label">Label</label>
                            <Field as="select"
                              name="modelType"
                              type="text"
                              className="form-control"
                              placeholder="Select Label"
                              disabled={isPujaStartedOrCompleted}
                            >
                              <option value="lead">Lead</option>
                              <option value="booking">Booking</option>
                              <option value="nurture">Nurture</option>
                            </Field>
                            <Field type="hidden" name="discountAmount" />
                            <Field type="hidden" name="manualDiscountValue" />
                            <Field type="hidden" name="discountType" />
                            <Field type="hidden" name="variantId" />

                          </div>
                        )}

                        {/* User Address Selection Dropdown */}
                        {(initialValues.userId || values.userId) && (
                          <div className="mb-3 col-md-6">
                            <label className="form-label">Select User Address <span className="text-danger">*</span></label>
                            <Select
                              name="addressId"
                              options={userAddresses.map((address) => ({
                                value: address?.id,
                                label: `${address.fullAddress}${address.locality ? `, ${address.locality}` : ''}`,
                                fullAddress: address.fullAddress,
                                locality: address.locality,
                                direction: address.direction
                              }))}
                              isDisabled={values.bookingStatus === 'puja_started' || (values.bookingStatus === 'puja_completed' && !['admin', 'superadmin'].includes(role))}
                              onChange={async (selectedOption) => {
                                setFieldValue("addressId", selectedOption?.value || null)
                                setGeoPriceInfo(null)

                                if (selectedOption) {
                                  const fullAddressText = [
                                    selectedOption.fullAddress,
                                    selectedOption.locality,
                                    selectedOption.direction
                                  ].filter(Boolean).join(', ');
                                  setFieldValue("userAddress", fullAddressText);

                                  // Fetch geo price if puja is already selected
                                  if (values.serviceId) {
                                    const geoPrice = await fetchGeoPrice(values.serviceId, selectedOption.value, values.variantId || null);
                                    if (geoPrice !== null) {
                                      let newFinalPrice = geoPrice;
                                      setFieldValue("actualPrice", geoPrice);
                                      setFieldValue("discountAmount", 0);
                                      setFieldValue("finalPrice", geoPrice);

                                      const discountVal = parseFloat(values.manualDiscount);
                                      if (!isNaN(discountVal) && discountVal > 0) {
                                        let discount = 0;
                                        if (values.discountType === 'flat') {
                                          discount = Math.min(discountVal, geoPrice);
                                        } else {
                                          discount = (geoPrice * discountVal) / 100;
                                        }
                                        setFieldValue("discountAmount", discount.toFixed(2));
                                        newFinalPrice = parseFloat((geoPrice - discount).toFixed(2));
                                        setFieldValue("finalPrice", newFinalPrice);
                                      }

                                      // Persist geo price to DB so audit-payment reflects the change
                                      if (id) {
                                        ApiService.post('booking/update-data', {
                                          bookingId: values.bookingId,
                                          data: {
                                            addressId: selectedOption.value,
                                            actualPrice: geoPrice,
                                            finalPrice: newFinalPrice,
                                            discountAmount: parseFloat(values.discountAmount) || 0,
                                          }
                                        }).catch(err => console.error('[GeoPrice] Failed to persist price update:', err));
                                      }
                                    }
                                  }
                                } else {
                                  setFieldValue("userAddress", "");
                                  // Reset price to base price of the selected variant or puja
                                  const baseOption = values.variantId
                                    ? variants.find(v => v.value === values.variantId)
                                    : service.find(s => s.value === values.serviceId);
                                  if (baseOption?.price) {
                                    setFieldValue("actualPrice", baseOption.price);
                                    setFieldValue("finalPrice", baseOption.price);
                                    setFieldValue("discountAmount", 0);
                                  }
                                }
                              }}
                              value={userAddresses.map((address) => ({
                                value: address?.id,
                                label: `${address.fullAddress}${address.locality ? `, ${address.locality}` : ''}`,
                                fullAddress: address.fullAddress,
                                locality: address.locality,
                                direction: address.direction
                              })).find((option) => option.value === values?.addressId)}
                              placeholder="Choose an existing address..."
                              isClearable
                            />
                            {errors.addressId && <div style={{ color: 'red', fontSize: '0.875em' }}>{errors.addressId}</div>}
                          </div>
                        )}

                        {id && (
                           <div className="mb-3 col-md-12 text-end">
                             <button
                               type="button"
                               className="btn btn-primary"
                               disabled={values.bookingStatus === 'puja_started' || (values.bookingStatus === 'puja_completed' && !['admin', 'superadmin'].includes(role)) || !isAnyFieldUpdated(values)}
                               onClick={() => handleCommonUpdate(values)}
                             >
                               Update
                             </button>
                           </div>
                         )}
                        {/* Payment Link Options (Visible in Step 1 and subsequent steps) */}
                        {values.paymentStatus !== 'done' && (
                          <div className="col-md-12 mb-4">
                            <h6 className="mb-3 fw-bold">Payment Plan for Link</h6>
                            <div className="row g-3">
                              {/* Advance Payment Card */}
                              <div className="col-md-6">
                                <div
                                  className={`p-3 rounded border h-100 ${(initialValues?.adminPaymentType || paymentHistory.length > 0) ? "bg-light text-muted" : "bg-white"} ${selectedPaymentType === 'advance' ? 'border-primary shadow-sm' : ''}`}
                                  style={{
                                    cursor: (initialValues?.adminPaymentType || paymentHistory.length > 0) ? 'not-allowed' : 'pointer',
                                    borderWidth: selectedPaymentType === 'advance' ? '2px' : '1px',
                                    opacity: (initialValues?.adminPaymentType || paymentHistory.length > 0) && selectedPaymentType !== 'advance' ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    if (!initialValues?.adminPaymentType && paymentHistory.length === 0) setSelectedPaymentType('advance');
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-2">
                                    <input type="radio" checked={selectedPaymentType === 'advance'} readOnly className="form-check-input mt-0" disabled={!!initialValues?.adminPaymentType || paymentHistory.length > 0} />
                                    <strong className="ms-2">Pandit Booking Advance</strong>
                                  </div>
                                  <div className="ms-4">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                      <span className={`${initialValues?.adminPaymentType ? "text-muted" : "text-muted"} small`}>Pay ₹</span>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        style={{ width: '90px' }}
                                        value={advanceAmount}
                                        onChange={(e) => {
                                          if (!initialValues?.adminAdvanceAmount && paymentHistory.length === 0) setAdvanceAmount(e.target.value);
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        disabled={!!initialValues?.adminAdvanceAmount || paymentHistory.length > 0}
                                        readOnly={!!initialValues?.adminAdvanceAmount || paymentHistory.length > 0}
                                      />
                                      <span className={`${initialValues?.adminPaymentType ? "text-muted" : "text-muted"} small`}>now</span>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                      Remaining ₹{Math.max(0, parseFloat(values.finalPrice || values.actualPrice || 0) - parseFloat(advanceAmount || 0)).toFixed(0)} post-service
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Full Payment Card */}
                              <div className="col-md-6">
                                <div
                                  className={`p-3 rounded border h-100 ${(initialValues?.adminPaymentType || paymentHistory.length > 0) ? "bg-light text-muted" : "bg-white"} ${selectedPaymentType === 'full' ? 'border-success shadow-sm' : ''}`}
                                  style={{
                                    cursor: (initialValues?.adminPaymentType || paymentHistory.length > 0) ? 'not-allowed' : 'pointer',
                                    borderWidth: selectedPaymentType === 'full' ? '2px' : '1px',
                                    opacity: (initialValues?.adminPaymentType || paymentHistory.length > 0) && selectedPaymentType !== 'full' ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    if (!initialValues?.adminPaymentType && paymentHistory.length === 0) setSelectedPaymentType('full');
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-2">
                                    <input type="radio" checked={selectedPaymentType === 'full'} readOnly className="form-check-input mt-0" disabled={!!initialValues?.adminPaymentType || paymentHistory.length > 0} />
                                    <strong className="ms-2">Full Payment</strong>
                                  </div>
                                  <div className="ms-4">
                                    <div className={`h5 mb-1 ${initialValues?.adminPaymentType ? "" : "text-success"}`}>
                                      ₹{Math.round(parseFloat(values.finalPrice || values.actualPrice || 0))}
                                      {(values.discountAmount > 0) && (
                                        <span className={`ms-2 badge ${initialValues?.adminPaymentType ? "bg-secondary" : "bg-success-subtle text-success border border-success-subtle"}`} style={{ fontSize: '0.65rem' }}>
                                          {values.discountType === 'percentage' ? `${values.manualDiscountValue}%` : `₹${values.manualDiscountValue}`} OFF
                                        </span>
                                      )}
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                      Total Savings: ₹{Math.round(values.discountAmount || 0)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Manual Send/Resend button - only for existing bookings (Step 2/3) */}
                            {id && selectedPaymentType && (
                              <div className="mt-3 d-flex align-items-center gap-3 flex-wrap">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm px-4"
                                  onClick={() => sendPaymentLink(values.bookingId, selectedPaymentType)}
                                >
                                  <i className="fa fa-paper-plane me-1"></i>
                                  { (initialValues?.paymentLinkSent || paymentHistory.length > 0) ? 'Resend Payment Link' : 'Send Payment Link'}
                                </button>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Payment Details for New Bookings */}
                        {(!id) && (
                          <div className="col-md-12 mb-4">
                            <div className="card p-3">
                              <h5>Payment Details</h5>
                              <p className="text-muted small">Record initial payment if customer has paid during booking creation</p>
                              <div className="row">
                                <div className="col-md-4">
                                  <label className="form-label">Payment Method</label>
                                  <select
                                    className="form-select"
                                    value={initialPaymentData.paymentMethod}
                                    onChange={(e) => {
                                      const paymentMethod = e.target.value;
                                      setInitialPaymentData({ ...initialPaymentData, paymentMethod });
                                    }}
                                  >
                                    <option value="">Select payment method</option>
                                    <option value="cash">Cash</option>
                                    <option value="card">Card</option>
                                    <option value="upi">UPI</option>
                                  </select>
                                </div>

                                <div className="col-md-4">
                                  <label className="form-label">Amount (₹)</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter amount"
                                    value={initialPaymentData.amount}
                                    onChange={(e) => setInitialPaymentData({ ...initialPaymentData, amount: e.target.value })}
                                  />
                                </div>

                                {initialPaymentData.paymentMethod === 'upi' && (
                                  <div className="col-md-4">
                                    <label className="form-label">UPI Payment ID</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter UPI transaction ID"
                                      value={initialPaymentData.paymentId}
                                      onChange={(e) => setInitialPaymentData({ ...initialPaymentData, paymentId: e.target.value })}
                                    />
                                  </div>
                                )}
                              </div>
                              {initialPaymentData.paymentMethod && initialPaymentData.amount && (
                                <div className="alert alert-info mt-3 mb-0">
                                  <i className="fa fa-info-circle"></i> Payment of ₹{initialPaymentData.amount} via {initialPaymentData.paymentMethod} will be recorded
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row mb-4">
                        {(values?.bookingStatus === 'cancelled' && values.cancelRemark) && (
                          <p className="font-bold">Cancel Remark: {values.cancelRemark}</p>
                        )}
                      </div>

                      {/* Payment Status Toggle */}
                      {id && values?.bookingStatus !== 'pending' && values?.bookingStatus !== 'lead' && values?.bookingStatus !== 'cancelled' && (
                        <div className="row mb-4">
                          <div className="col-md-4">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="paymentStatusToggle"
                                checked={values.paymentStatus === 'done'}
                                onChange={() => {
                                  const newPaymentStatus = values.paymentStatus === 'done' ? 'pending' : 'done';
                                  setFieldValue("paymentStatus", newPaymentStatus);

                                  // Update payment status immediately via API
                                  ApiService.post('booking/update-data', {
                                    bookingId: values.bookingId,
                                    data: {
                                      paymentStatus: newPaymentStatus,
                                      bookingStatus: values.bookingStatus,
                                      finalPrice: values.finalPrice || null,
                                      actualPrice: values.actualPrice || null,
                                      discountAmount: values.discountAmount || null,
                                      promoCodeId: values.promoCodeId || null,
                                      campaignId: values.campaignId || null,
                                      serviceId: values.serviceId || null,
                                      variantId: values.variantId || null,
                                      pujaDateTime: values.pujaDateTime || null,
                                      addressId: values.addressId,
                                      discountType: values.discountType || null,
                                      manualDiscountValue: values.manualDiscountValue || null,
                                      modelType: values.modelType || null
                                    }
                                  }).then(() => {
                                    toast.success(`Payment status updated to ${newPaymentStatus}`);
                                    getBookingById(); // Refresh booking data
                                  }).catch(err => {
                                    console.error('Error updating payment status:', err);
                                    toast.error('Failed to update payment status');
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor="paymentStatusToggle">
                                Payment Status: <strong>{values.paymentStatus === 'done' ? 'Paid' : 'Pending'}</strong>
                              </label>
                            </div>
                          </div>
                          {/* Legacy Send Payment Link button removed; replaced by Payment Plan UI above */}
                          {/* {initialValues?.userAddress ? (
                            <div className="col-md-4">
                              <button 
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setShowAddressModal(true)}
                              >
                                Update User Address
                              </button>
                            </div>
                          ) : (
                            <div className="col-md-3">
                              <button 
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setShowAddressModal(true)}
                              >
                                Add User Address
                              </button>
                            </div>
                          )} */}
                        </div>
                      )}

                      {/* Legacy payment cards removed - unified center rendered below Form */}

                      {(values?.bookingStatus !== 'cancelled' && values?.bookingStatus !== 'refund_initiate' && values?.bookingStatus !== 'puja_started' && values?.bookingStatus !== 'puja_completed' && values?.bookingStatus !== 'refund_done') && (
                        // Only show the bottom button for new bookings OR when it represents a specific transition (Confirm/Assign)
                        (!id || getButtonText() !== 'Update') && (
                          <button
                            type={id ? values.bookingStatus === 'pending' ? 'button' : 'submit' : 'submit'}
                            disabled={isSubmitting}
                            className="btn btn-primary"
                            onClick={() => {
                              if (id && values.bookingStatus === 'pending') {
                                confirmBooking(values);
                              }
                            }}
                          >
                            {getButtonText()}
                          </button>
                        )
                      )}
                    </Form>
                    {id && (
                      <div className="audit-payment-control-center mt-4">
                        {/* 3.2 Payment Transaction History Table */}
                        <div className="card mb-4 shadow-sm">
                          <div className="card-header bg-light">
                            <h4 className="card-title mb-0">Transaction History</h4>
                          </div>
                          <div className="card-body">
                            {paymentHistory.length === 0 ? (
                              <p className="text-muted text-center my-3">No payments recorded for this booking yet.</p>
                            ) : (
                              <div className="table-responsive">
                                <table className="table table-bordered table-striped table-hover mb-0">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Date</th>
                                      <th>Stage</th>
                                      <th>Amount</th>
                                      <th>Transaction ID / Ref</th>
                                      <th>Method</th>
                                      <th>Status</th>
                                      <th>Invoice</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {paymentHistory.map((payment, idx) => {
                                      // Link to invoice based on payment stage
                                      const invoiceUrl = payment.paymentStage === 'advance' ? values.proformaInvoiceUrl : values.finalInvoiceUrl;
                                      return (
                                        <tr key={idx}>
                                          <td>
                                            {new Date(payment.createdAt).toLocaleString("en-GB", {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: true
                                            })}
                                          </td>
                                          <td>
                                            <span className={`badge ${payment.paymentStage === 'advance' ? 'bg-info' : 'bg-success'}`}>
                                              {payment.paymentStage || 'final'}
                                            </span>
                                          </td>
                                          <td className="fw-bold">₹{payment.amount}</td>
                                          <td className="font-monospace small">{payment.transactionId || payment.paymentId || 'N/A'}</td>
                                          <td className="text-capitalize">{payment.paymentMethod}</td>
                                          <td>
                                            <span className={`badge ${payment.status === 'paid' || payment.status === 'success' || payment.status === 'captured' ? 'bg-success' : 'bg-warning'}`}>
                                              {payment.status || 'paid'}
                                            </span>
                                          </td>
                                          <td>
                                            {invoiceUrl ? (
                                              <a href={invoiceUrl} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-link text-primary p-0">
                                                <i className="fa fa-file-pdf-o"></i> View Invoice
                                              </a>
                                            ) : (
                                              <span className="text-muted small">Not Available</span>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {!id && promoResponse && isPromoCodeApplied && (
                      <div className="card mt-3">
                        <div className="card-body">
                          <h5 className="card-title">Promo Code Details</h5>
                          <div className="row">
                            <div className="col-md-6">
                              <p><strong>Promo Code:</strong> {promoResponse.promoCode.code}</p>
                              <p><strong>Discount Type:</strong> {promoResponse.promoCode.discountType === 'flat' ? 'Flat' : 'Percentage'}</p>
                              <p><strong>Discount Amount:</strong> ₹{promoResponse.discountAmount}</p>
                            </div>
                            <div className="col-md-6">
                              <p><strong>Actual Price:</strong> ₹{promoResponse.actualPrice}</p>
                              <p><strong>Final Price:</strong> ₹{promoResponse.finalPrice}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {(values.bookingStatus === 'samagri_delivered' || values.bookingStatus === 'puja_started') && (
                      <div className="flex justify-end mb-4">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => { completedBooking(values, 'puja_completed') }}
                        >
                          Completed
                        </button>
                      </div>
                    )}
                    {values.bookingStatus === 'puja_completed' && (
                      <div className="card mt-3 mb-4">
                        <div className="card-header">
                          <h5 className="card-title mb-0">Dakshina</h5>
                        </div>
                        <div className="card-body">
                          <div className="row align-items-end g-3">
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Promised Dakshina (₹)</label>
                              <input
                                type="number"
                                className="form-control"
                                value={values.panditPayout || ''}
                                disabled
                              />
                              <small className="text-muted">Pre-set from puja service</small>
                            </div>
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">Actual Dakshina Paid (₹)</label>
                              <Field
                                type="number"
                                name="dakshinaPaid"
                                className="form-control"
                                placeholder="Enter actual amount paid"
                                min="0"
                              />
                              <small className="text-muted">Actual amount given to pandit</small>
                            </div>
                            <div className="col-md-4">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={async () => {
                                  try {
                                    await ApiService.post('booking/update-data', {
                                      bookingId: values.bookingId,
                                      data: { dakshinaPaid: values.dakshinaPaid || null }
                                    });
                                    toast.success('Dakshina updated successfully');
                                    getBookingById();
                                  } catch (error) {
                                    toast.error('Failed to update dakshina');
                                  }
                                }}
                              >
                                Save Dakshina
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!(
                      values.bookingStatus === 'cancelled' ||
                      values.modelType === 'lead' ||
                      values.bookingStatus === 'puja_completed' ||
                      values.bookingStatus === 'refund_done' ||
                      id === undefined
                    ) && (
                        <div className="flex justify-end">
                          <button
                            onClick={() => setShowModal(true)}
                            className="btn btn-danger"
                          >
                            Cancel Booking
                          </button>
                        </div>
                      )}
                  </div>
                </>
                );
              }}
            </Formik>
          </div>
          {/* Cancel Bookking Modal */}
          <CancelBookingModal showModal={showModal} setShowModal={setShowModal} bookingId={bookingId} beId={userId} tickets={tickets} />
          <TicketResolveModal showModal={showTicketModal} setShowModal={setShowTicketModal} ticketId={ticketId} bookingId={bookingId} requestType={requestType} />
          {/* Address Booking Modal */}
          <AddressBookingModal
            showModal={showAddressModal}
            setShowModal={setShowAddressModal}
            bookingId={bookingId}
            userId={initialValues?.userId}
            onAddressSubmit={handleAddressSubmit}
            initialAddress={initialValues?.address ? initialValues.address : null}
          />
        </div >
        {
          tickets.length > 0 && (

            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Booking Tickets</h4>
              </div>
              <div className="card-body">
                <div className="row">
                  {tickets.map((ticket) => (
                    <div key={ticket.id} className="col-md-6">
                      <div className="card mb-3">
                        <div className="card-body">
                          <h5 className="card-title">
                            Request Type: <span className="text-capitalize">{ticket.requestType}</span>
                          </h5>
                          <p>
                            <strong>Status:</strong> {ticket.status}
                          </p>
                          <p>
                            <strong>Comment:</strong> {ticket.comment}
                          </p>
                          {ticket.resolveComment && ticket.resolvedAt && (

                            <p>
                              <strong>Resolve Comment:</strong> {ticket.resolveComment}<br></br>
                              <strong>Resolved At:</strong> {
                                new Date(ticket.resolvedAt).toLocaleString("en-GB", {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true
                                })}
                            </p>
                          )}
                          <p>
                            <strong>Created At:</strong>{" "}
                            {new Date(ticket.createdAt).toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true
                            })}
                          </p>
                          {ticket.status === "pending" && (
                            <button
                              className="btn btn-success"
                              onClick={() => openTicketModal(ticket.id, id, ticket.requestType)}
                            //onClick={() => updateTicketStatus(ticket.id, id, ticket.requestType)}
                            >
                              Mark as Resolved
                            </button>
                          )}
                          {ticket.status === "resolved" && (
                            <span className="badge bg-success">Resolved</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        }

        {/* Legacy manual invoice mail trigger card removed - replaced by automated generation & send logic */}

        {
          (initialValues.bookingStatus === 'puja_completed') && (
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Checkin/Checkout Photos</h4>
              </div>
              <div className="card-body">
                <label className="form-label">Puja Checkin Photos</label>
                <div className="row">
                  {initialValues.pujaCheckinFilesArray && initialValues.pujaCheckinFilesArray.length > 0 &&
                    initialValues.pujaCheckinFilesArray.map((image, index) => (
                      <div key={index} className="mb-3 col-md-4">
                        <a href={image} target="_blank" rel="noopener noreferrer"><img src={image} alt={`Puja Checkin ${index + 1}`} className="image-item" /></a>
                      </div>
                    ))
                  }
                </div>
                <label className="form-label">Puja Checkout Photos</label>
                <div className="row">
                  {initialValues.pujaCheckoutFilesArray && initialValues.pujaCheckoutFilesArray.length > 0 &&
                    initialValues.pujaCheckoutFilesArray.map((image, index) => (
                      <div key={index} className="mb-3 col-md-4">
                        <a href={image} target="_blank" rel="noopener noreferrer"><img src={image} alt={`Puja Checkin ${index + 1}`} className="image-item" /></a>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          )
        }

      </div >
    </div >
  )
}